import API from '../../../common/http/api.fetch';
import { formatDate } from '../../../common/utils/util.date';
import { DATE_FORMAT } from '../../../common/utils/util.constants';
import * as TYPE from '../reporting.action.types';
import {getDocFileNameFromPath} from "../../../common/utils/util.path";

export const getAuditReports = (filter) => {
    return (dispatch) => {
        return API.fetch({
            url: `/reporting/audits`,
            method: 'GET',
            params: {
                arr_id: filter.auditRun,
                loc_uuid: filter.location,
                offset: filter.offset,
                limit: filter.limit
            }
        }).then(({ data }) => {
            dispatch({
                type: 'GRID_FETCH',
                id: filter.identifier,
                //items: data.items,
                items: data.items.map(item => {
                    return {
                        headOffice:    item.hof_name,
                        siteLocation:  item.slo_name,
                        createdAt:     item.created_at,
                        startDate:     formatDate(item.start_date, DATE_FORMAT.INPUT),
                        endDate:       formatDate(item.end_date, DATE_FORMAT.INPUT),
                        fileName:      getDocFileNameFromPath(item.doc_uri) || '',
                        uri:           item.doc_uri,
                        errorMessage:  item.error_message,
                        status:        item.status_name,
                        runType:       item.run_type_name
                    };
                }),
                itemsCount: parseInt(data.items_count)
            })
        });
    }
}

export const getAuditReportRuns = () => {
    return (dispatch) => {
        return API.fetch({
            url: `/reporting/audit-runs`,
            method: 'GET',
            params: {}
        }).then(({ data }) => {
            dispatch({
                type: TYPE.AUDIT_REPORT_RUNS,
                id: 'reportingAuditGrid',
                path: 'auditRuns',
                items: data.items.map((item) => {
                    return {
                        value: item.arr_id,
                        label: item.created_at,
                    };
                }),
            })
        });
    }
}

export const generateAuditReport = (data) => {
    return (dispatch) => {
        return API.fetch({
            url: `/reporting/generate-audit-report`,
            method: 'POST',
            data: {
                run_type: "manrun",
                loc_uuid: data.location,
                start_date: formatDate(data.startDate, DATE_FORMAT.OUTPUT),
                end_date: formatDate(data.endDate, DATE_FORMAT.OUTPUT),
            }
        }).then(() => {
            dispatch({
                type: TYPE.AUDIT_REPORT_RESET,
                id: 'auditReport',
            })
        });
    }
}
